var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentUser)?_c('div',[_c('h1',{staticClass:"p-pt-5",attrs:{"id":"welcome_header"}},[_vm._v(" Welcome, "+_vm._s(_vm.currentUser)+"! ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }